import api from "../api";
import UIComponent from "../ui/component";

export class TranscribeToolBar extends UIComponent {
    init() {
    }
}
